module.exports = __webpack_public_path__ + "static/img/page62.f93363d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page62.png
// module id = W9NB
// module chunks = 0